export default function requestUtilityApi(
  { state, utilityApiClient },
  { action, queryId, payload, timeout, onError, onSuccess },
) {
  return utilityApiClient.postWithState({
    action: action,
    queryId: queryId,
    state: state,
    payload: payload,
    timeout: timeout,
    onError: onError,
    onSuccess: onSuccess,
  });
}
